
export const CompareText = (a, b, field) => {
    return a[field].localeCompare(b[field], "no");
}

export const CustomTextCompare = (a, b, dir, field) => {
    const correction = dir === 'asc' ? 1 : -1;
    return correction * CompareText(a, b, field);
};

export const isWhitespace = (str) => {
    return str.trim().length === 0;
}
